import { useTranslation } from 'react-i18next';
import { useHasPermission } from '../../../../contexts/auth';
import { TENANT_ROUTES } from '../../tenantConfig.routes';
import { TenantSection } from './tenantSection.component';

/** Who the workspace is, and what it is paying for. */
export const TenantWorkspaceSection = () => {
  const { t } = useTranslation();
  const canViewSubscription = useHasPermission('payment.view_tenantsubscription');

  return (
    <TenantSection
      tabs={[
        { key: 'overview', label: t('Overview'), path: TENANT_ROUTES.overview },
        ...(canViewSubscription
          ? [{ key: 'subscription', label: t('Subscription'), path: TENANT_ROUTES.subscription }]
          : []),
      ]}
    />
  );
};
